<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
		
      <div class="dlblock-mb20 mr10">
        <span class="pr5">单词</span>
        <el-input v-model.trim="word" placeholder="请输入" style="width: 150px;"/>
      </div>

     <div class="dlblock-mb20 mr10">
        <span class="pr5">包名</span>
        <el-input v-model.trim="chinese" placeholder="请输入" style="width: 150px;"/>
      </div>
	  
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="date"
	        style="width: 300px;"
	        type="daterange"
	        value-format="yyyy-MM-dd"
	        range-separator="至"
	        start-placeholder="开始日期"
	        end-placeholder="结束日期"/>
	  </div>
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getEnWordPackageListPageFn()">
          搜索
        </el-button>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="editBtn(1)">
          新增
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="id" label="编号"></el-table-column>
      <el-table-column align="center" prop="name" label="包名"></el-table-column>
      <el-table-column align="center" prop="introduce" label="介绍"></el-table-column>
	  
	  <el-table-column align="center"  label="图片">
	    <template slot-scope="{row}">
	      <el-image class="m-box-img" :src="row.picture" @click="editBtn(3,row)" lazy></el-image>
	    </template>
	  </el-table-column>
	  
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" width="150" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a"  @click="editBtn(2, row)">修改</a>
          <a class="glob-a"  @click="auditShow = {modal: true, data: row}">查看</a>
		  <a class="glob-a"  @click="statusBtn(1, row)">包中单词</a>
		   <a class="glob-a"  @click="editBtn(5, row)">删除</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 详情 -->
    <el-dialog :title="detailName" :visible.sync="detailModal" fullscreen>
      <detail :id="detailId"/>
    </el-dialog>
	
    <!-- 查看 -->
    <el-dialog title="查看包" :visible.sync="auditShow.modal" width="800px">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="包名：">
              {{auditShow.data.name}}
            </el-form-item>
          </el-col>
        </el-row>
		<el-row>
			<el-col :span="12">
			  <el-form-item label="简介：">
			    {{auditShow.data.introduce}}
			  </el-form-item>
			</el-col>
		</el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="创建时间：">
              {{auditShow.data.create_time}}
            </el-form-item>
          </el-col>
        </el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="图片：">
				  <el-image class="m-box-img" :src="auditShow.data.picture"  @click="editBtn(4)" lazy></el-image>
		    </el-form-item>
		  </el-col>
		</el-row>
      </el-form>
    </el-dialog>

  <!-- 新增编辑 -->
    <el-dialog :title="editData.add === 1 ? '新增包' : '编辑包'" :visible.sync="editData.modal" width="500px">
      <el-form label-width="120px">
        <el-form-item label="包名：">
          <el-input v-model.trim="editData.name" placeholder="请输入包名"/>
        </el-form-item>
        <el-form-item label="图片：">
			<el-row>
			  <word-package-img class="mr10 mb10" v-model="editData.picture" :total="1"/>
			</el-row>
        </el-form-item>
		<el-form-item label="简介：">
		  <el-input v-model.trim="editData.introduce" placeholder="请输入简介"/>
		</el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="editData.modal = false">取 消</el-button>
        <el-button type="primary" @click="addBtn">确 定</el-button>
      </div>
    </el-dialog>
	
	<!-- 图片放大 -->
	<el-dialog title="查看" :visible.sync="imgPreData.modal" width="800px">
	  <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
	</el-dialog>
	
  </div>
</template>

<script>
	import Detail from './Detail.vue'
	import WordPackageImg from '@/components/WordPackageImg.vue'
    import {
    getEnWordPackageListPage,
    saveOrEditEnWordPackage,
	removeEnWordPackage
  } from '@/api'

  export default {
    name: 'WordPackage',
	components: {Detail,WordPackageImg},
    data () {
      return {
		word:'',
		chinese:'',
        date: '',
        userName: '',
        tableData: [],
        tableLoading: false,
        auditData: {
          modal: false,
          data: {},
          type: 'PASS',
          content: ''
        },
        auditShow: {
          modal: false,
          data: {}
        },
		//单词新增和修改
        editData: {
          modal: false,
          userId: '',
          add: 1,
          name: '',
          introduce: '',
          picture: []
        },
        typeList: [],
        pages: {
          page: 1,
          total: 0
        },
		imgTotal: 1,
		// 图片上传
		imgUploadData: {
		  modal: false,
		  urlList: []
		},
		// 图片放大
		imgPreData: {
		  modal: false,
		  url: ''
		},
		// 详情
		detailId: '',
    detailModal: false,
    //包名
    detailName:''
      }
    },
    created () {
      this.getEnWordPackageListPageFn()
    },
    methods: {
      getEnWordPackageListPageFn () {
        this.tableLoading = true
        getEnWordPackageListPage({
          pageNum: this.pages.page,
          startTime: this.date && this.date.length ? this.date[0] : '',
          endTime: this.date && this.date.length > 1 ? this.date[1] : '',
          word: this.word,
          chinese: this.chinese
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
	  getEnwordMarkDeleteFn (id) {
	    this.tableLoading = true
	    removeEnWordPackage(id).then(res => {
	     this.$message.success(res.msg)
	     this.getEnWordPackageListPageFn()
	    }).finally(() => {
	      this.tableLoading = false
	    })	},
		// t: 1查看
		statusBtn (t, row) {
		  if (t == 1) {
		    this.detailModal = true
        this.detailId = row.id
        //包名
        this.detailName = row.name
        console.info("包名",row);
		  }
		},
	  editBtn(t,row) {
		  //1新增 2修改 3列表查看图片 4查看里面的图片放大 5删除
		  if(t == 1){
			 this.editData = {
			   modal: true,
			   userId: '',
			   add: 1,
			   name: '',
			   introduce: '',
			   picture: []
			 }
		  }else if(t == 2){
			  this.editData = {
			    modal: true,
			    id: row.id,
			    add: 2,
			    name: row.name,
			    introduce: row.introduce,
			    picture: row.picture==null ? [] : [row.picture]
			  }
		  }else if(t == 3) {
	      this.imgPreData = {
	        modal: true,
	        url: row.picture
	      }
	    }else if(t == 4) {
	      this.imgPreData = {
	        modal: true,
	        url: this.auditShow.data.picture
	      }
	    }else if(t == 5){
			this.$confirm(`确认要删除吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
				 let id =  [row.id]
			     this.getEnwordMarkDeleteFn(id);
			});
			
		}
	},
	addBtn (t) {
	  if (this.editData.add == 1) {
	    saveOrEditEnWordPackage({
	      name: this.editData.name,
	      introduce: this.editData.introduce,
	      picture: this.editData.picture[0]
	    }).then(res => {
	      this.editData.modal = false
	      this.$message.success(res.data)
	      this.getEnWordPackageListPageFn()
	    })
	  } else {
	    saveOrEditEnWordPackage({
	      id: this.editData.id,
	      name: this.editData.name,
	      introduce: this.editData.introduce,
	      picture: this.editData.picture[0]
	    }).then(res => {
	      this.editData.modal = false
	      this.$message.success(res.data)
	      this.getEnWordPackageListPageFn()
	    })
	  }
	},
	uploadSave() {
	  if (this.imgUploadData.urlList && this.imgUploadData.urlList.length) {
	    addImage(this.imgUploadData.urlList.map(item => ({pictureUrl: item}))).then(res => {
	      this.$message.success(res.data)
	      this.imgUploadData.modal = false
	      this.getImagePageFn()
	    })
	  }
	},
      pageChange (val) {
        this.pages.page = val
        this.getEnWordPackageListPageFn()
      }
    }
  }
</script>

<style scoped>
  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }

  .type-ul {
    margin-top: 10px;
    max-height: 400px;
    overflow: auto;
  }

  .type-li {
    display: flex;
    align-items: center;
    line-height: 40px;
    border-bottom: 1px solid #d0d3da;
  }

  .type-li p {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
